export default {
    intro: ({ values }: { values: { isAuto: boolean; questionTime: number; answerTime: number } }) => {
        const { isAuto, questionTime, answerTime } = values;
        if (isAuto) {
            return `Xem câu hỏi trong ${answerTime} giây và chọn đúng hoặc sai trong ${questionTime} giây!`;
        } else {
            return 'Xem câu hỏi và chọn O/X!';
        }
    },
    options: {
        auto: 'Tự động tiến hành',
        manual: 'Tiến hành thủ công',
        timer: 'Cài đặt hẹn giờ',
        answerTime: 'Thời gian xem câu hỏi',
        questionTime: 'Thời gian chọn đáp án',
        answerCheckTime: 'Thời gian kiểm tra đáp án',
        showOtherAvatar: 'Hiển thị tất cả Avatar',
        showOtherAvatarDescription: 'Chọn hiển thị Avatar của Học sinh khác khi chọn OX trên màn hình Học sinh.',
    },
    topbar: {
        check: 'Hãy kiểm tra câu hỏi.',
        question: 'Hãy chọn đáp án.',
        result: 'Công bố đáp án!',
        default: 'OX Quiz thú vị',
    },
    buttons: {
        standby: 'Công bố câu hỏi',
        question: 'Kết thúc chọn và công bố đáp án',
        check: 'Bắt đầu chọn',
        unclickUser: {
            unselect: 'Xem số người<br />chưa chọn',
            allSelect: 'Tất cả <br />đã chọn!',
            count: '{count} người',
        },
        next: 'Câu hỏi tiếp theo',
    },
    modal: {
        unselect: 'Học sinh chưa chọn',
        timerError: 'Nếu muốn bắt đầu OX Quiz ở chế độ tự động,<br>hãy thiết lập cả 3 bộ hẹn giờ.',
    },
    toast: {
        unselect: 'Trước khi chọn đáp án, hãy kiểm tra câu hỏi trước!',
    },
    standbyStep: ({ values }: { values: { index: number } }) => {
        const { index } = values;
        const messages = [
            'Đang bơm khí<br />vào bóng bay...',
            'Đang làm nóng<br />khinh khí cầu...',
            'Đang kiểm tra<br />an toàn...',
        ];
        return messages[index];
    },
    resultStep: {
        result: 'Đáp án là <i></i>.',
        nextQuestion: 'Câu hỏi tiếp theo sau {time} giây!',
    },
    autoMode: 'Đang tiến hành ở chế độ tự động.',
    questionAccuracy: {
        content: ({ values }: { values: { questionText: string; correctChoice: boolean } }) => {
            const { questionText, correctChoice } = values;
            return `${questionText} <strong>${correctChoice ? '(O: Đúng)' : '(X: Sai)'}</strong>`;
        },
    },
    correctChoice: {
        true: 'Đúng',
        false: 'Sai',
    },
    question: 'Câu hỏi',
    answer: 'Đáp án',
    explanation: 'Giải thích',
    additionalMaterial: 'Tài liệu bổ sung',
    explanationMaterial: 'Tài liệu giải thích',
    table: {
        question: 'Câu hỏi',
        answerRate: 'Độ chính xác',
    },
    isAnswer: 'Đáp án là?',
    roundNumber: 'Số {number}',
    timer: {
        remaining: '{count} giây',
    },
};
